/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { TicketTextCanvas } from './TicketTextCanvas';
import { TicketContainer, TICKET_CHANGE_EVENTS } from '../tickets/TicketContainer';
import { TICKET_LOCATION_NAME_SETTINGS } from './TICKET_TEXT_SETTINGS';
import { FancyGraphics } from '@appCanvasCommon/graphics/FancyGraphics';
import { FancyContainer } from '@appCanvasCommon/graphics/FancyContainer';
import { FancyTextStyle } from '@appCanvasCommon/interfaces/fancy-text-style.interface';
import { Side } from '@touchplan/common';
import { CanvasAngularLand } from 'src/app/app-data/interfaces/canvas-angular-land';
import { Ticket } from '@touchplan/common';
import { setTicketWidthHelper } from 'src/app/utils/ticket-utils';
import { EventMode } from '@appCanvasCommon/events/event-mode.enum';

export class TicketLocationNameCanvas extends TicketTextCanvas {
	// TODO: Apply the mask globally on the world
	public maskContainer: FancyContainer = new FancyContainer();
	public maskGraphics: FancyGraphics = new FancyGraphics();
	private canvasAngularLand: CanvasAngularLand;

	constructor(
		canvasAngularLand: CanvasAngularLand,
		ticketContainer: TicketContainer,
		text: string = '',
		style: FancyTextStyle = new FancyTextStyle({ wordWrap: true, fill: '#ffffff' }),
		canvas?: HTMLCanvasElement
	) {
		super(text, style, canvasAngularLand, ticketContainer, canvas);

		this.maskContainer.mask = this.maskGraphics;
		this.canvasAngularLand = canvasAngularLand;
		this.maskContainer.addChild(this);

		ticketContainer.ABOVE.addChild(this.maskGraphics);

		ticketContainer.on(TICKET_CHANGE_EVENTS.CHANGED, this.onChanged);

		this.onChanged(ticketContainer);
		this.eventMode = EventMode.None;
	}

	public onChanged = (ticketContainer: any) => {
		const data: Ticket = ticketContainer.getData();
		const layout = ticketContainer.getLayout();
		if (!data.view.location) {
			this.renderable = false;
		} else {
			const pullSuffix = data.view.side === Side.PULL ? '_PULL' : '';

			this.x = TICKET_LOCATION_NAME_SETTINGS['LEFT_MARGIN' + pullSuffix] || 0;
			this.y = TICKET_LOCATION_NAME_SETTINGS['TOP_MARGIN' + pullSuffix] || 0;

			const paddingRight: number = TICKET_LOCATION_NAME_SETTINGS['RIGHT_MARGIN' + pullSuffix] || 0;
			const height: number = TICKET_LOCATION_NAME_SETTINGS['DRAWING_AREA_HEIGHT' + pullSuffix] || 0;

			const width = setTicketWidthHelper(data, layout, this.canvasAngularLand.wideTicketSize$.getValue());
			this.style.wordWrapWidth = width - paddingRight - this.x;

			// Draw text mask
			this.maskGraphics.clear();
			this.maskGraphics.beginFill(0x000000, 1);
			this.maskGraphics.drawRect(this.x, 0, this.style.wordWrapWidth, height);
			this.maskGraphics.endFill();

			this.renderable = true;
			this.tint = this.ticket.locationTextColor;

			this.setText(data.view.location?.view.name);
			if (data.view.side === Side.PULL) {
				this.style.fontSize = 32;
			} else {
				this.style.fontSize = 18;
			}
		}
	};

	public override destroy(options?): void {
		this.ticket.off(TICKET_CHANGE_EVENTS.CHANGED, this.onChanged);
		this.maskContainer.destroy(options);

		this.maskContainer = null;
		this.maskGraphics = null;
		super.destroy(options);
	}
}
